<template>
  <v-container id="reference-term-list">
    <v-row>
      <v-col cols="7" md="7" class="breadcrumbs">
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>

      <v-col cols="5" sm="5">
        <div class="text-right">
          <div cols="10" class="d-flex">
            <app-modal-import-group-solution
              :color="'success'"
              :icon="'mdi-plus-circle'"
              @onSave="loadAxis()"
              :possuiMunicipio="true"
              v-if="isFullAdmin"
            >
              <template v-slot:title>
                Exportar
                {{
                  isAT
                    ? "Grupo de Iniciativa"
                    : isGov
                    ? "Grupo de Fases"
                    : "Grupo de Solução"
                }}
              </template>
            </app-modal-import-group-solution>
            <app-modal-insert-group-solution
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              @onSave="loadGroupSolutions"
            >
              <template v-slot:title>
                Cadastrar
                {{
                  isAT
                    ? "Grupo de Iniciativa"
                    : isGov
                    ? "Grupo de Fases"
                    : "Grupo de Solução"
                }}
              </template>
            </app-modal-insert-group-solution>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="groupSolutions"
          item-key="name"
          class="elevation-1"
        >
          <template v-slot:item.descricao="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  {{ diminuirValue(item.descricao) }}</span
                >
              </template>
              <div style="max-width: 500px">{{ item.descricao }}</div>
            </v-tooltip>
          </template>
          <template v-slot:item.acoes="{ item }">
            <v-row>
              <v-col cols="4">
                <app-modal-insert-group-solution
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  @onSave="loadGroupSolutions"
                >
                  <template v-slot:title>
                    Edição de
                    {{
                      isAT
                        ? "Grupo de Iniciativa"
                        : isGov
                        ? "Grupos de Fases"
                        : "Grupos de Solução"
                    }}
                  </template>
                </app-modal-insert-group-solution>
              </v-col>

              <v-col cols="4">
                <app-modal-delete-group-solution
                  :payload="item"
                  @onDelete="loadGroupSolutions"
                >
                  <template v-slot:title>
                    Deletar
                    {{
                      isAT
                        ? "Grupo de Iniciativa"
                        : isGov
                        ? "Grupos de Fases"
                        : "Grupos de Solução"
                    }}
                  </template>
                </app-modal-delete-group-solution>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { groupSolutionAPI } from "../API/GroupSolutionAPI";
import AppModalInsertGroupSolution from "./ModalInsert";
import AppModalDeleteGroupSolution from "./ModalDelete";
import { mapActions, mapGetters } from "vuex";
import AppModalImportGroupSolution from "@/modules/group-solution/components/city/ModalImport";
import { compare } from "@/helpers/orderByAsc";

export default {
  name: "AppSolutionList",
  components: {
    AppModalInsertGroupSolution,
    AppModalDeleteGroupSolution,
    AppModalImportGroupSolution,
  },
  data() {
    return {
      headers: [],
      breadcrumbs: [
        {
          text: "Grupos de Soluções",
          disabled: true,
          href: "eixo",
        },
      ],
      groupSolutions: [],
    };
  },
  mounted() {
    this.headers = [
      {
        text: "#",
        value: "grupoSolucaoId",
        sortable: false,
      },
      {
        text: this.isAT
          ? "Grupo de Iniciativa"
          : this.isGov
          ? "Grupo de Fases"
          : "Grupo de Solução",
        align: "left",
        value: "nome",
      },
      {
        text: "Descrição",
        value: "descricao",
      },
      {
        text: "Ações",
        value: "acoes",
        sortable: false,
      },
    ];

    if (this.isAT) {
      this.breadcrumbs = [
        {
          text: "Grupos de Iniciativas",
          disabled: true,
          href: "eixo",
        },
      ];
    }
    this.loadGroupSolutions();
  },
  computed: {
    ...mapGetters(["loading", "isAT", "isFullAdmin", "isGov"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    diminuirValue(item) {
      if (item && item.length > 50) {
        return item.substring(0, 50) + "...";
      }

      return item;
    },
    loadGroupSolutions() {
      this.setLoading(true);
      groupSolutionAPI
        .list()
        .then((resp) => {
          this.groupSolutions = resp.data.sort((a, b) => compare(a, b, "nome"));
          this.setLoading(false);
          this.$emit("reload");
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            `Erro ao listar ${
              this.isAT ? "Grupo de Iniciativa" : "Grupo de Solução"
            }`
          );
        });
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
